export default `
  query listOrgMembers($orgId: String!, $limit: Int, $nextToken: String) {
    listOrgMembers(orgId: $orgId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgId
        userId
        role
        email
        user {
          id
          firstname
          lastname
          email
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`
